<script lang="ts">
  import { defineComponent, watchEffect } from "vue";
  import { useRouter } from "vue-router";

  import { requestLoginStatus } from "frontend/api/application/request-misc";
  import { useStore } from "frontend/stores/login";
  import { UserEntity } from "frontend/interfaces/user";

  import BaseLogo from "frontend/components/base/BaseLogo.vue";
  import ZugangTelemedizinLogin from "frontend/components/base/ZugangTelemedizinLogin.vue";

  export default defineComponent({
    components: { BaseLogo, ZugangTelemedizinLogin },
    setup() {
      const router = useRouter();

      const onPracticeLogin = () => {
        router.push({
          name: "calendar", // goto calendar view
        });
      };

      const loginStore = useStore();
      requestLoginStatus();

      watchEffect(() => {
        if (loginStore.isLoggedIn(UserEntity.Practice)) onPracticeLogin();
        if (loginStore.isLoggedIn(UserEntity.Patient))
          router.push({
            name: "patient",
          });
      });

      return {
        loginStore,
      };
    },
  });
</script>

<template>
  <div class="vue-route__login--index">
    <div class="plain plain--spacious">
      <div class="login-form">
        <BaseLogo />
        <h2>Login</h2>
        <form
          v-if="loginStore.csrfToken"
          data-turbo="false"
          method="post"
          action="/auth/praxisapp"
        >
          <input
            type="hidden"
            name="authenticity_token"
            v-bind:value="loginStore.csrfToken"
          />
          <button>
            <input type="submit" class="hidden" />
            Login über PraxisApp-Verwaltung
          </button>
        </form>
        <h2>Hausärztliche Praxen</h2>
        <p>
          Der Login zur Online-Terminverwaltung über den "Zugang-Telemedizin"
          steht bisher nur für hausärztliche Praxen zur Verfügung. Andere
          Fachgruppen werden folgen.
        </p>
        <form
          v-if="loginStore.csrfToken"
          data-turbo="false"
          method="post"
          action="/auth/zugang_telemedizin"
        >
          <input
            type="hidden"
            name="authenticity_token"
            v-bind:value="loginStore.csrfToken"
          />
          <label>
            <input type="submit" class="hidden" />
            <ZugangTelemedizinLogin />
          </label>
        </form>
        <div v-else>laden</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @use "shared/styles/colors";

  .vue-route__login--index {
    display: flex;
    justify-content: center; // horizontally
    align-items: center; // vertically
  }

  .login-form {
    max-width: 400px;
  }

  .login-form__inputs {
    margin: 20px 0;
  }

  .login-form__errors {
    color: colors.$color_login-form__errors--text;
    font-size: 14px;
  }

  .login-form__hidden-submit {
    display: none;
  }

  .hidden {
    display: none;
  }
</style>
